import React from 'react'
import SEOHead from '../components/shared/SEOHead'
import { getPageSEO } from '../utils/seoConfig'
import Login from '../components/auth/Login'

const AuthPage: React.FC = () => {
  return (
    <>
      <SEOHead seo={getPageSEO("auth")} />
      <Login />
    </>
  )
}

export default AuthPage
